import { appStore } from '@tom-ui/utils'
import { useAllocationRulesMessageHandler } from '@yard/pages/YardSetup/hooks/useAllocationRulesMessageHandler'
import { CarrierVisitAllocationRulesViewStore } from '@yard/pages/YardSetup/stores/allocation-rules/carrier-visit-allocation-rules.view-store'
import { CarrierVisitOverviewViewStore } from '@yard/pages/YardSetup/stores/carrier-visit-overview.viewstore'
import { YardViewStore } from '@yard/pages/YardSetup/stores/yard.view-store'
import { FC } from 'react'
import { AllocationRulesActions } from '../../../atoms/AllocationRules/AllocationRulesActions'

type Props = {
  yardViewStore: YardViewStore
  carrierVisitOverviewViewStore: CarrierVisitOverviewViewStore
  carrierVisitAllocationRulesViewStore: CarrierVisitAllocationRulesViewStore
}

export const CarrierVisitAllocationRulesActions: FC<Props> = props => {
  const { yardViewStore, carrierVisitAllocationRulesViewStore, carrierVisitOverviewViewStore } =
    props

  const { getExceptionMessage, getCarrierVisitRulesSuccessMessage } =
    useAllocationRulesMessageHandler()

  const submitRules = async () => {
    try {
      await carrierVisitAllocationRulesViewStore.submitRules()
      carrierVisitAllocationRulesViewStore.setAllocationRulesDrawerOpen(false)
      yardViewStore.setCreateRuleFromFilter(false)
      appStore.setShowAlert('success', getCarrierVisitRulesSuccessMessage())
    } catch (e) {
      appStore.setShowAlert('error', getExceptionMessage(e))
    }
  }

  return (
    <AllocationRulesActions
      onSubmit={submitRules}
      onCancel={() => {
        carrierVisitAllocationRulesViewStore.resetChanges()
        carrierVisitOverviewViewStore.setOverviewOpen(true)
        yardViewStore.setCreateRuleFromFilter(false)
      }}
      isFilterDrawerOpen={yardViewStore.isFilterDrawerOpen}
    />
  )
}
